
import { Course } from '../types';

export const legal_standards: Course = {
  id: "legal_standards",
  title: "Evidence & Standards",
  description: "Learn how the court weighs evidence and the standard of proof required to win.",
  icon: "📊",
  totalModules: 10,
  modules: {
    1: { id: 1, title: "Slide 1", slides: [{ title: "Slide 1", content: `<div class="flex justify-center"><img src="/images/courses/legal_standards/Slide1.PNG" alt="Slide 1" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    2: { id: 2, title: "Slide 2", slides: [{ title: "Slide 2", content: `<div class="flex justify-center"><img src="/images/courses/legal_standards/Slide2.PNG" alt="Slide 2" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    3: { id: 3, title: "Slide 3", slides: [{ title: "Slide 3", content: `<div class="flex justify-center"><img src="/images/courses/legal_standards/Slide3.PNG" alt="Slide 3" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    4: { id: 4, title: "Slide 4", slides: [{ title: "Slide 4", content: `<div class="flex justify-center"><img src="/images/courses/legal_standards/Slide4.PNG" alt="Slide 4" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    5: { id: 5, title: "Slide 5", slides: [{ title: "Slide 5", content: `<div class="flex justify-center"><img src="/images/courses/legal_standards/Slide5.PNG" alt="Slide 5" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    6: { id: 6, title: "Slide 6", slides: [{ title: "Slide 6", content: `<div class="flex justify-center"><img src="/images/courses/legal_standards/Slide6.PNG" alt="Slide 6" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    7: { id: 7, title: "Slide 7", slides: [{ title: "Slide 7", content: `<div class="flex justify-center"><img src="/images/courses/legal_standards/Slide7.PNG" alt="Slide 7" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    8: { id: 8, title: "Slide 8", slides: [{ title: "Slide 8", content: `<div class="flex justify-center"><img src="/images/courses/legal_standards/Slide8.PNG" alt="Slide 8" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    9: { id: 9, title: "Slide 9", slides: [{ title: "Slide 9", content: `<div class="flex justify-center"><img src="/images/courses/legal_standards/Slide9.PNG" alt="Slide 9" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    10: { id: 10, title: "Slide 10", slides: [{ title: "Slide 10", content: `<div class="flex justify-center"><img src="/images/courses/legal_standards/Slide10.PNG" alt="Slide 10" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] }
  },
  quiz: [
    {
        "q": "According to 'The Pyramid of Proof,' what does Tier 1, 'Foundations,' primarily involve?",
        "o": [
            "Presenting evidence with credibility in the courtroom.",
            "Gathering, evaluating, and submitting tangible proof.",
            "Grasping the legal thresholds and burdens required by the judge.",
            "Developing a strategy for cross-examining opposing witnesses."
        ],
        "a": 2
    },
    {
        "q": "What is the required standard of proof in Family Court, as defined by 'The 51% Rule'?",
        "o": [
            "Beyond a reasonable doubt (99%).",
            "A preponderance of evidence (75%).",
            "Balance of Probabilities (51%).",
            "Clear and convincing evidence (65%)."
        ],
        "a": 2
    },
    {
        "q": "In Family Court, if an individual makes an allegation (e.g., abuse or parental alienation), who carries the burden of proving that allegation?",
        "o": [
            "The court, to ensure fairness for all parties.",
            "The accused, to disprove the allegation.",
            "The person making the allegation (the accuser).",
            "Legal aid, to represent both parties equally."
        ],
        "a": 2
    },
    {
        "q": "Which type of evidence is generally given 'significantly less weight' by judges in family court because the original speaker cannot be cross-examined?",
        "o": [
            "Direct Evidence.",
            "Documentary Evidence.",
            "Contemporaneous Notes.",
            "Hearsay."
        ],
        "a": 3
    },
    {
        "q": "To legally admit a covert recording into family court evidence, what is typically required?",
        "o": [
            "A notarized affidavit from the person who made the recording.",
            "Explicit permission from the court, often through a specific formal court order.",
            "Confirmation that all parties involved were aware they were being recorded.",
            "Submission of the recording within 24 hours of its creation."
        ],
        "a": 1
    }
]
};
